<template>
  <router-link
    :to="{name: 'season_info', params: {seasonId: seasonId}}"
  >{{text}}</router-link>
</template>

<script>
export default {
  name: 'SeasonLink',

  props: {
    seasonId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'season',
    },
  },

  computed: {
    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.seasonId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      } else {
        return idStr;
      }
    },
  },
};
</script>
